import { useEffect } from "react";

const usePreventBackNavigation = (setShowingWarning) => {
  useEffect(() => {
    const handleBack = (event) => {
      event.preventDefault();
      setShowingWarning(true);
      window.history.pushState(null, '', window.location.href);
    }

    window.history.pushState(null, '', window.location.href);
    
    window.addEventListener('popstate', handleBack);

    return () => {
      window.removeEventListener('popstate', handleBack);
    }

  }, [setShowingWarning]);
}

export default usePreventBackNavigation;
